import React from "react";
import { makeStyleguideTemplate } from "tsi-common-react/src/styleguide/makeStyleguideTemplate";

import { templates } from "@reactivated";

import { toolboxComponentsMap } from "../blocks/toolboxComponentsMap";
import { basicPageComponentsMap } from "../components/BasicPageBody";
import { homePageComponentsMap } from "../components/HomePageBody";
import { informationPageComponentsMap } from "../components/InformationPageBody";
import { productPageComponentsMap } from "../components/ProductPageBody";
import { reviewsPageComponentsMap } from "../components/ReviewsPageBody";
import { productComparePageComponentsMap } from "../components/SealyProductComparePageBody";
import { StyleguideChrome } from "../components/StyleguideChrome";
import { utilityPageComponentsMap } from "../components/UtilityPageBody";
import { buildProductModulesComponentsMap } from "../components/productModulesBody";
import {
    leftSideBarComponents,
    rightSideBarComponents,
} from "./UtilityPageTemplate";

// The PDP `modules` map closes over page-derived SSR side-channels that the
// styleguide's 3-prop (block/map_key/bg_color) render path cannot deliver.
// The fixture-routed pdp blocks (CarouselModule -> `carousel`,
// FeaturesModule -> `features_block`) consume none of them, so build the map
// with zeroed props.
const pdpComponentsMap = buildProductModulesComponentsMap({
    reviews: {},
    pageNumReviews: 0,
    changeVariantSSR: {},
    changeRootSSR: {},
    rootConditionalSSR: {},
    variantConditionalSSR: {},
    tabCardsInitialRootProductID: 0,
});

const registry = {
    toolbox: toolboxComponentsMap,
    home: homePageComponentsMap,
    information: informationPageComponentsMap,
    basic: basicPageComponentsMap,
    product_page: productPageComponentsMap,
    reviews: reviewsPageComponentsMap,
    product_compare: productComparePageComponentsMap,
    pdp: pdpComponentsMap,
    utility: utilityPageComponentsMap,
    utility_left_sidebar: leftSideBarComponents,
    utility_right_sidebar: rightSideBarComponents,
};

const StyleguideBlocks = makeStyleguideTemplate(registry, {
    // The PDP module assembly (ProductModulesBody) renders blocks with a bare
    // Fragment StreamField — no Wagtail wrapper div. `.block-features_block`
    // carries layout CSS, so the wrapper's duplicate class would apply it
    // twice and distort the render.
    bareMapKeys: ["pdp"],
});

export const Template = (
    props: templates.StyleguideBlockTemplate,
): React.JSX.Element => {
    const inner = (
        <StyleguideBlocks
            block={props.block}
            map_key={props.map_key}
            bg_color={props.bg_color}
        />
    );
    return (
        <StyleguideChrome storybook={props.storybook}>
            {props.storybook ? inner : <div id="block-tester">{inner}</div>}
        </StyleguideChrome>
    );
};
